/* eslint-disable class-methods-use-this */
import React, { Component } from 'react'
import { Modal, message } from 'antd'
import * as useAuth from '../../../utils/auth'
import messageSuccess from '../../collect/messageSuccess'
import request from '../../../utils/request'
import Icon from '../../icon'
import ModalConfirm from '../../modal/modalConfirm'
import toSourceName from '../../../common/toSourceName'
import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM } from '../../platformConfig'
import MnAntdProvider from '../../../common/antdPrefix'
import './index.less'
import ModalContent from './modalContent'

const MODES = { COLLECT: '1', PURCHASE: '2' }
const QUERY_TYPE = { ALL: 3, COOP: 2, MY: 1 }

const getBlogList = (batchSelected, currentViewBlog = {}) => {
  const { imageGroupEntityId, platformId, mnPlatformType, colorId, sitePlatformId, skc } = currentViewBlog
  return batchSelected?.length
    ? batchSelected
    : [{
      blogId: imageGroupEntityId,
      platformId: Number(platformId) || mnPlatformType,
      colorId,
      sitePlatformId,
      skc,
    }]
}

async function addOrRemoveToIdeaMass(params) {
  const add = _params => request.post('/zhikuan/ins/inspiration/add-into-inspiration-new', _params)
  const remove = _params => request.post('/zhikuan/ins/inspiration/remove-from-inspiration', _params)
  const result = params.currentFlag ? await remove(params) : await add(params)
  return result
}
class AddInspirationModal extends Component {
  static defaultProps = {
    currentViewBlog: null,
  }

  constructor(props) {
    super(props)
    const { currentViewBlog } = props

    this.state = {
      inspirationGroups: [],
      loading: true,
      start: 0,
      isEnd: false,
      currentViewBlog: { ...currentViewBlog, ...currentViewBlog?.lastBlogList?.[0] },
      tags: new Set(),
      skuImage: null,
      mode: MODES.COLLECT,
      keyWords: '',
      description: currentViewBlog?.description,
      currentFlagNum: 0,
      queryType: QUERY_TYPE.ALL,
      userInfo: JSON.parse(sessionStorage.getItem('account')) || {},
    }
  }

  async componentDidMount() {
    const { batchSelected } = this.props
    const { currentViewBlog, queryType, keyWords } = this.state
    this.fetchMode()
    const blogId = currentViewBlog.imageGroupEntityId
    this.fetchIdeaMassList(queryType, blogId, keyWords)
    if (!batchSelected?.length) {
      const imgTags = await this.fetchTags()
      this.setState({ tags: new Set(imgTags.map(t => t.tagName)) })
    }
  }

  // 创建新灵感集时，自动将当前博客加入灵感集
  async onCreateInspiration(inspirationId, inspirationName, images) {
    const { batchSelected } = this.props
    const { currentViewBlog = {}, keyWords, description, queryType } = this.state
    const { imageGroupEntityId, itemOriginDTO } = currentViewBlog
    const blogList = getBlogList(batchSelected, currentViewBlog)
    batchSelected?.length ? this.batchAddTag() : this.addTag()
    const defaultParams = { currentFlag: 0, inspirationId, blogList, description, itemOriginDTO }
    const _params = blogList.length > 1 ? defaultParams : { ...defaultParams, saveImgUrlList: images }

    addOrRemoveToIdeaMass(_params).then(res => {
      if (!res) return
      this.fetchIdeaMassList(queryType, imageGroupEntityId, keyWords)
      messageSuccess({
        collectIdList: res.collectIdList,
        name: inspirationName,
        loginUserInfo: res.loginUserInfo,
        data: res,
        toViewUrl: `/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}`,
      })
    })
  }

  async onAddTag(tag) {
    const { batchSelected } = this.props
    const { currentFlagNum, tags } = this.state
    await this.setState({ tags: tags.add(tag) })
    if (currentFlagNum && !batchSelected?.length) {
      this.addTag()
    }
  }

  async onDeleteTag(tag) {
    const { batchSelected } = this.props
    const { tags, currentFlagNum } = this.state
    tags.delete(tag)
    await this.setState({ tags })
    if (currentFlagNum && !batchSelected?.length) {
      this.deleteTag(tag)
    }
  }

  onChangeMainImage(skuImage) {
    this.setState({ skuImage })
  }

  async onJoin(params) {
    const { batchSelected, onClose, afterJoin } = this.props
    const { currentViewBlog, description, inspirationGroups } = this.state
    const { imageGroupEntityId, itemOriginDTO } = currentViewBlog || {}
    const { insPurchaseItemParam } = params || {}
    const shelveStatus = await this.fetchShelveStatus(
      imageGroupEntityId,
      (insPurchaseItemParam?.skuColor || null), (
        insPurchaseItemParam?.skuMeasurement || null)
    )
    if (!shelveStatus) {
      message.error('该商品已经下架，不支持采买')
      return
    }
    const blogList = getBlogList(batchSelected, currentViewBlog)
    batchSelected?.length ? this.batchAddTag() : this.addTag()
    const res = await addOrRemoveToIdeaMass({ currentFlag: 0, blogList, ...params, description, itemOriginDTO })
    if (!res) return
    onClose?.()
    const inspiration = inspirationGroups.find(m => m.id === params.idList[0])
    messageSuccess({
      collectIdList: res.collectIdList,
      name: inspiration?.name,
      loginUserInfo: res.loginUserInfo,
      data: res,
      toViewUrl: `/meinian/home/coll/detail/${inspiration.id}?inspirationId=${inspiration?.id}`,
    })
    afterJoin?.()
  }

  onChangeTab(tab, blogId, keyWords) {
    this.setState({ queryType: tab, start: 0, isEnd: false })
    this.fetchIdeaMassList(tab, blogId, keyWords)
  }

  setMode(mode) {
    try {
      request.get(`/backend-api/sso-api/common/setting/set?key=ins:insCollectMode&value=${mode}`)
      this.setState({ mode })
    } catch (error) {
      console.error(error)
    }
  }

  async fetchIdeaMassList(queryType, blogId, keyWords, start = 0) {
    const { inspirationGroups, currentViewBlog } = this.state
    this.setState({ loading: true })
    try { // 兼容跨境platformId
      const res = await request.post(`/zhikuan/ins/inspiration/list-simple-inspiration?pageSize=24&start=${start}`, { queryType, blogId, platformId: currentViewBlog.platformId || currentViewBlog.mnPlatformType, likeName: keyWords })
      const list = start === 0 ? res.resultList : [...inspirationGroups, ...res.resultList]
      if (!res.resultList?.length) {
        this.setState({ isEnd: true })
      }
      this.setState({ inspirationGroups: list, start: start + 24, currentFlagNum: res.param?.currentFlagNum || 0 })
    } catch (err) {
      console.error('fetchIdeaMassList', err)
    }
    this.setState({ loading: false })
  }

  async fetchShelveStatus(blogId, skuColor, skuMeasurement) {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/judge-shelves', { params: { blogId, skuColor, skuMeasurement } })
      return res
    } catch (err) {
      console.error(err)
    }
  }

  async fetchTags() {
    const { currentViewBlog } = this.state
    const { imageGroupEntityId } = currentViewBlog || {}
    try {
      const res = await request.get('/zhikuan/img-tag/list-img-tag', { params: { entityId: imageGroupEntityId } })
      return res
    } catch (error) {
      console.error(error)
    }
  }

  async fetchMode() {
    try {
      const res = await request.get('/backend-api/sso-api/common/setting/get', { params: { key: 'ins:insCollectMode' } })
      this.setState({ mode: res || MODES.COLLECT })
    } catch (error) {
      console.error(error)
    }
  }

  async addTag() {
    const { currentViewBlog, tags, description } = this.state
    const { imageGroupEntityId, platformId } = currentViewBlog || {}
    if (!tags.size) {
      return
    }
    try {
      await request.post('/zhikuan/img-tag/add-img-tag', { entityId: imageGroupEntityId, platformId: Number(platformId), description, tagNameList: Array.from(tags) })
    } catch (error) {
      console.error(error)
    }
  }

  async batchAddTag() {
    const { batchSelected } = this.props
    const { tags } = this.state
    if (!tags.size) {
      return
    }
    try {
      await request.post('/zhikuan/img-tag/batch-add', { blogList: batchSelected.map(m => ({ entityId: m.blogId })), tagNameList: Array.from(tags) })
    } catch (error) {
      console.error(error)
    }
  }

  async deleteTag(tag) {
    const { currentViewBlog } = this.state
    const { imageGroupEntityId } = currentViewBlog || {}
    try {
      const imgTags = await this.fetchTags()
      await request.post('/zhikuan/img-tag/delete-img-tag', { entityId: imageGroupEntityId, tagId: imgTags.find(m => m.tagName === tag).id })
    } catch (error) {
      console.error(error)
    }
  }

  async beforeJoin(inspiration, saveImgUrlList) {
    const { currentViewBlog, description, currentFlagNum } = this.state
    const { platformId, itemOriginDTO } = currentViewBlog || {}
    const { currentFlag: _currentFlag, id, childId, name } = inspiration
    const { inspirationGroups } = this.state
    const currentFlag = this.props.batchSelected?.length ? 0 : _currentFlag
    const inspirationId = childId || id
    const blogList = getBlogList(this.props.batchSelected, currentViewBlog)

    if (inspiration.loading) return
    inspiration.loading = true
    this.setState({ inspirationGroups })
    if (this.props.batchSelected?.length) {
      this.batchAddTag()
    }
    if (!currentFlag && !this.props.batchSelected?.length) {
      this.addTag()
    }

    try {
      const res = await request.post('/ins/inspiration/calculate-no-collect-num', { currentFlag, blogList, inspirationId, description, itemOriginDTO })
      const joinNum = blogList?.length
      if (res && res !== joinNum) {
        ModalConfirm.show({
          title: '采集提示',
          content: `${joinNum - res}个款式已在灵感集 ${name} 中存在，将采集剩余${res}个款式。`,
          onOk: () => this.toggleJoin(
            inspiration,
            currentFlagNum,
            currentFlag,
            blogList,
            inspirationId,
            description,
            itemOriginDTO,
            platformId,
            saveImgUrlList,
          ),
          onClose: () => inspiration.loading = false
        })
        return
      }
      this.toggleJoin(inspiration, currentFlagNum, currentFlag, blogList, inspirationId, description, itemOriginDTO, platformId, saveImgUrlList)
    } catch (error) {
      console.error(error)
    }
    inspiration.loading = false
    this.setState({ inspirationGroups })
  }

  async toggleJoin(inspiration, currentFlagNum, currentFlag, blogList, inspirationId, description, itemOriginDTO, platformId, saveImgUrlList) {
    try {
      const defaultParams = { currentFlag, blogList, inspirationId, description, itemOriginDTO }
      const _params = blogList.length > 1 ? defaultParams : { ...defaultParams, saveImgUrlList }
      const res = await addOrRemoveToIdeaMass(_params)
      if (res.errorCode === 'MEINIAN_MEAL_AUTH_ERROR_0019') {
        message.error('由于团队版本降级，您需要先前往美念选择需要保留的灵感集。')
        return
      }
      if (res?.errorCode === 'INS0029') { // 单独处理该错误消息
        message.error(res.errorDesc)
        return
      }
      if (!res?.errorCode) { // 上传错误的时候 得走上传图片的逻辑
        inspiration.currentFlag ^= 1
        if (!currentFlag) {
          messageSuccess({
            collectIdList: res.collectIdList,
            name: inspiration?.name,
            loginUserInfo: res.loginUserInfo,
            data: res,
            toViewUrl: `/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}`,
          })
          if (res?.effectTargetNum && useAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) && res.collectIdList?.length <= 1) {
            this.props?.onAssociateTask?.({ inspiration, inspirationId, res, collectIdList: res.collectIdList, loginUserInfo: res.loginUserInfo })
          }
          this.props.onClose()
          this.props.afterJoin && this.props.afterJoin()
        } else {
          this.setState({ currentFlagNum: currentFlagNum - 1 })
        }
      } else {
        this.uploadIns(inspiration, platformId, res.collectIdList, res.loginUserInfo)
      }
    } catch (err) {
      console.error('toggleJoin', err)
    }
  }

  async uploadIns(inspiration, platformId, collectIdList, loginUserInfo) {
    // 判断平台，抖音采集出现错误转为上传采集
    // 采集出现错误时转为上传采集
    const { mainUrl, picUrl, isCollectReport } = this.state?.currentViewBlog || {}
    const { id, childId, name } = inspiration
    const { tags, description } = this.state
    const inspirationId = id || childId

    if (isCollectReport || platformId === PLATFORM_VALUE.DY) {
      try {
        const itemList = [{
          mainUrl: mainUrl || picUrl,
          desc: description || '',
          tagNameList: Array.from(tags),
          title: ''
        }]
        const res = await request.post('/zhikuan/user-img/upload-img', { inspirationIdList: [inspirationId], itemList })
        messageSuccess({
          collectIdList: res.collectIdList,
          loginUserInfo,
          name,
          data: res,
          toViewUrl: `/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}`,
        })
        if (res?.effectTargetNum && useAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) && res.collectIdList?.length <= 1) {
          this.props?.onAssociateTask?.({ inspiration, inspirationId, res, collectIdList: res.collectIdList, loginUserInfo: res.loginUserInfo })
        }
        this.props.onClose()
        this.props?.afterJoin?.()
      } catch (err) {
        message.error(err.errorDesc || err)
      }
    } else {
      message.error('采集失败')
    }
  }

  render() {
    const { visible, onClose, batchSelected = [] } = this.props
    const { currentViewBlog = {}, tags, skuImage, mode, description,
      loading, start, isEnd, inspirationGroups, keyWords, queryType, userInfo } = this.state
    const { imageGroupEntityId,
      mainUrl,
      insDataDTO,
      insItemDataDTO,
      weiboDataDTO, itemDataDTO, xhsDataDTO, dyItemDataDTO, picUrl } = currentViewBlog || {}
    const platformId = Number(currentViewBlog?.platformId)
    const currentDto = currentViewBlog?.[PLATFORM_CONFIG_ENUM.get(platformId).dto]

    const {
      textContent, season, originGender, city, brand, title, magazineName, columnName,
      itemName, productName, picList, picUrlList, runwayDataDTO, contentType,
    } = { ...currentViewBlog, ...currentDto }
    const source = toSourceName(platformId, currentDto)
    // 博客名称
    const nickName = insDataDTO?.bloggerName || weiboDataDTO?.bloggerName || xhsDataDTO?.bloggerName || insItemDataDTO?.bloggerName
    const visibleWhalePick = userInfo.isWhalePick && platformId === PLATFORM_VALUE.ITEM
     && (!batchSelected || batchSelected?.length <= 1)

    let text = textContent
    switch (platformId) {
      case 2: text = (season || '') + (city || '') + (brand || ''); break
      case 9: text = (season || '') + (originGender || '') + (city || '') + (brand || ''); break
      case 40: text = (`${season} ` || '') + (brand || ''); break
      case PLATFORM_VALUE.XIAOHONGSHU: text = title; break
      case PLATFORM_VALUE.CROSSBORDER: text = itemName; break
      case PLATFORM_VALUE.INSGOODS: text = productName; break
      case PLATFORM_VALUE.PORTER: text = brand; break
      case PLATFORM_VALUE.FARFETCH: text = brand; break
      case PLATFORM_VALUE.SSENSE: text = brand; break
      case PLATFORM_VALUE.CROSSBORDER_INS_GOODS: text = productName; break
      case PLATFORM_VALUE.CROSSBORDER_SHOW: text = (season || '') + (city || '') + (brand || ''); break
      case PLATFORM_VALUE.DY_WORKS: text = title; break
      case PLATFORM_VALUE.XIU_CHANGE_XI_JIE: text = (`${runwayDataDTO?.season} ` || '') + (`${runwayDataDTO?.brand} ` || '') + (`${contentType} ` || ''); break
      case PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN:
        if (columnName === '杂志大片') {
          text = (`${season} ` || '') + (`${magazineName}-` || '') + (columnName || '')
        } else {
          text = (`${season} ` || '') + (`${brand}-` || '') + (columnName || '')
        }
        break
      default: text = textContent
    }

    const imageNum = batchSelected?.length || currentDto?.imageNum || currentViewBlog?.imageNum || picList?.length || picUrlList?.length
    const blogList = getBlogList(batchSelected, currentViewBlog)

    return <MnAntdProvider>
      <Modal
      visible={visible}
      bodyStyle={{ padding: 0, width: 884 }}
      width="auto"
      onCancel={onClose}
      closable={false}
      footer={false}
      centered
      wrapClassName="mn-add-into-idea-mass-modal-wrapper"
    >
      <div className="mn-add-into-idea-mass-modal-header">
        采集至美念
        <div className="add-into-idea-mass-modal-close" onClick={onClose}><Icon type="m-guanbi" /></div>
      </div>
      <ModalContent
        imageNum={imageNum}
        imageGroupEntityId={imageGroupEntityId}
        platformId={platformId || currentViewBlog.mnPlatformType}
        itemDataDTO={itemDataDTO}
        dyItemDataDTO={dyItemDataDTO}
        userInfo={userInfo}
        source={source}
        nickName={nickName}
        text={text}
        visibleWhalePick={visibleWhalePick}
        tags={tags}
        description={description}
        mode={blogList.length > 1 ? MODES.PURCHASE : mode}
        setState={this.setState.bind(this)}
        setMode={this.setMode.bind(this)}
        onClose={onClose}
        skuImage={skuImage}
        picUrl={picUrl}
        mainUrl={mainUrl}
        colorId={currentViewBlog?.colorId}
        sitePlatformId={currentViewBlog?.sitePlatformId}
        skc={currentViewBlog?.skc}
        onChangeMainImage={this.onChangeMainImage.bind(this)}
        onAddTag={this.onAddTag.bind(this)}
        onDeleteTag={this.onDeleteTag.bind(this)}
        onJoin={this.onJoin.bind(this)}
        currentViewBlog={currentViewBlog}
        fetchIdeaMassList={this.fetchIdeaMassList.bind(this)}
        queryType={queryType}
        onChangeTab={this.onChangeTab.bind(this)}
        keyWords={keyWords}
        inspirationGroups={inspirationGroups}
        onCreateInspiration={this.onCreateInspiration.bind(this)}
        beforeJoin={this.beforeJoin.bind(this)}
        loading={loading}
        isEnd={isEnd}
        batchSelected={batchSelected}
        start={start}
        options={{ ...this.props, }}
      />
    </Modal>
    </MnAntdProvider>
  }
}

export default AddInspirationModal
